import ItemService from '@/services/item';

export default {
	namespaced: true,
	state: {
	},

	getters: {
    
	},

	actions: {
		async searchItem({commit, state, getters, dispatch},q){
			try{
				const response = await ItemService.searchItem(q);
				return response
			}catch(e){
				console.log(e)
			}
		},
		async searchItemWithDate({ commit, state, getters, dispatch }, payload) {
			try {
				let response = await ItemService.searchItemWithDate(payload)
				return response
			} catch (e) {
				console.log(e)
			}
		},
		async getItemsUnique({commit, state, getters, dispatch}){
			try{
				const response = await ItemService.getItemsUnique();
				return response
			}catch(e){
				console.log(e)
			}
    	},
	},

	mutations: {
		// SET_VALUE_FROM_API(state, payload) {
		// 	state.valueFromApi = payload;
		// }
	}
};
